export default {
  deleteTitle: 'User',
  overviewTitle: 'Users',
  overviewRouterUrl: 'users',
  getFilterName (context) { return 'users' },
  overviewApiUrl: '/users/',
  detailTitle: 'User Detail',
  detailRouterUrl: 'user',
  detailApiUrl: '/users/',
  quickFilterName: 'Name',
  quickFilterField: 'name',
  advancedSearch: false,
  disableDelete (rec) { return true },
  sortOrder: [
    {
      field: 'usr_login_name',
      sortField: 'usr_login_name',
      direction: 'asc'
    }
  ],
  fields:
  [
    {title: 'Login', name: 'usr_login_name', sortField: 'usr_login_name', link: '#/user/{id}'},
    {title: 'Name', name: 'usr_name', sortField: 'usr_name'},
    {title: 'Role', name: 'userrole_name', sortField: 'userrole_name'},
    {title: 'Active', name: 'usr_active', sortField: 'usr_active', callback: 'formatBoolean'},
    {name: '__slot:actions', title: '', titleClass: 'text-center', dataClass: 'text-center'}
  ]
}



// WEBPACK FOOTER //
// ./src/views/User/FieldDefs.js